'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

/* ---------------- DelayedobjectsListCtrl ---------------- */

EwSiteApp.controller('DelayedobjectsListCtrl', DelayedobjectsListCtrl);

DelayedobjectsListCtrl.$inject = ['$scope', '$http', '$filter', '$uibModal', '$log'];
function DelayedobjectsListCtrl($scope, $http, $filter, $uibModal, $log) {

	$scope.items = [];
	$scope.sortField = 'id';
	$scope.sortReverse = false;
	$scope.currentPage = 1;
	$scope.itemsPerPage = 20;
	$scope.totalItems = 0;
	$scope.numPages = undefined;
	$scope.filter = {};
	$scope.isFilters = false;
	$scope.canEdit = false;
	$scope.contractors = [];
	$scope.dataUrl = '';
	$scope.saveUrl = '';

	$scope.loadItems = function () {
		if ($scope.dataUrl !== '') {
			$http({
				method: 'GET',
				url: $scope.dataUrl
			})
					.then(function (response) {
						var data = response.data || {};
						if (data.success) {
							if (angular.isDefined(data.items)) {
								$scope.items = data.items;
								$scope.totalItems = $scope.items.length;
							}
							if (angular.isDefined(data.contractors)) {
								$scope.contractors = data.contractors;
							}
						} else if (angular.isDefined(data.message)) {
							$log.info(data.message);
						}
						if (angular.isDefined(data.debug)) {
							$log.debug(data.debug);
						}
					})
					.catch(function (err) {
						$log.error('Failed to load items', err);
					});
		} else {
			$log.warn('No URL! url_template: ' + $scope.dataUrl);
		}
	};

	$scope.sortState = function (col) {
		if ($scope.sortField === col) {
			return $scope.sortReverse ? -1 : 1;
		}
		return 0;
	};

	$scope.setSort = function (col) {
		if ($scope.sortField === col) {
			$scope.sortReverse = !$scope.sortReverse;
		} else {
			$scope.sortField = col;
			$scope.sortReverse = false;
		}
	};

	$scope.getPageList = function () {
		var ordered = $filter('filter')($scope.items, $scope.filter);
		$scope.totalItems = ordered.length;
		ordered = $filter('orderBy')(ordered, $scope.sortField, $scope.sortReverse);
		var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
		var end = start + $scope.itemsPerPage;
		return ordered.slice(start, end);
	};

	$scope.cleanFilters = function () {
		$scope.filter = {};
		$scope.setFilters();
	};

	$scope.setFilters = function () {
		$scope.isFilters = false;
		for (var i in $scope.filter) {
			if ($scope.filter[i] !== '') {
				$scope.isFilters = true;
			}
		}
	};

	$scope.sortingClass = function (fld) {
		var st = $scope.sortState(fld);
		if (st === 0)
			return 'sorting';
		if (st === 1)
			return 'sorting_asc';
		if (st === -1)
			return 'sorting_desc';
	};

	$scope.sortingArrow = function (fld) {
		var st = $scope.sortState(fld);
		if (st === 1)
			return 'fa-arrow-down';
		if (st === -1)
			return 'fa-arrow-up';
	};

	$scope.addItem = function () {
		var new_item = {
			id: '0',
			contractor: '',
			object: '',
			service: '',
			address: '',
			invnumber: '',
			deadline: '',
			delay_days: '',
			delay_reason: '',
			actions: '',
			planned_end: ''
		};
		$scope.editor(new_item);
	};

	$scope.editItem = function (item) {
		$scope.editor(item);
	};

	$scope.editor = function (item) {
		if (!$scope.canEdit) {
			return null;
		}
		var modalInstance = $uibModal.open({
			templateUrl: 'delayedobjects/item_edit.html',
			controller: 'DelayedobjectsItemEditCtrl',
			resolve: {
				item: function () {
					return item;
				},
				contractors: function () {
					return $scope.contractors;
				}
			}
		});

		modalInstance.result.then(function (result) {
			var url = $scope.saveUrl;
			if (url !== '') {
				$http({
					method: 'POST',
					url: url,
					data: result,
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				})
						.then(function (response) {
							var data = response.data || {};
							if (data.success) {
								if (angular.isUndefined(item.id) || item.id < 1) {
									$scope.items.push(data.item);
								} else {
									angular.extend(item, data.item);
								}
							} else if (angular.isDefined(data.message)) {
								$log.info(data.message);
							}
							if (angular.isDefined(data.debug)) {
								$log.debug(data.debug);
							}
						})
						.catch(function (err) {
							$log.error('Failed to save item', err);
						});
			} else {
				$log.warn('No URL! url_template: ' + $scope.saveUrl);
			}
		});
	};
}



EwSiteApp.controller('DelayedobjectsItemEditCtrl', DelayedobjectsItemEditCtrl);

DelayedobjectsItemEditCtrl.$inject = ['$scope', '$uibModalInstance', 'item', 'contractors'];
function DelayedobjectsItemEditCtrl($scope, $uibModalInstance, item, contractors) {
	$scope.require = {
		contractor: true
	};
	$scope.item = angular.copy(item);
	$scope.contractors = contractors;
	$scope.services = ['Elektra', 'Dujos'];

	$scope.isValid = function () {
		return ($scope.item.contractor_id > 0);
	};

	$scope.save = function () {
		if ($scope.item.contractor_id) {
			var clen = $scope.contractors.length;
			for (var i = 0; i < clen; i++) {
				if ($scope.contractors[i].id == $scope.item.contractor_id) {
					$scope.item.contractor_title = $scope.contractors[i].title;
					$scope.item.category_title = $scope.contractors[i].category_title;
					break;
				}
			}
		}
		$uibModalInstance.close($scope.item);
	};

	$scope.cancel = function () {
		for (var i in $scope.require) {
			if ($scope.require.hasOwnProperty(i)) {
				$scope.require[i] = false;
			}
		}
		$uibModalInstance.dismiss();
	};
}



